import { ScmSkusList } from './ScmSkusList';

export default {
    list: ScmSkusList
};
